const OFFER_TOKEN_PATTERN = /#NUM_COUPON_(\d+)#/;

export const offerToken = (index: number) => `#NUM_COUPON_${index}#`;

export const offerTokenChoices = (offerCount: number): string[] =>
  Array.from({ length: Math.max(1, offerCount) + 1 }, (_, index) => offerToken(index));

export const offerIndexOf = (text: string | undefined): number | null => {
  const match = text?.match(OFFER_TOKEN_PATTERN);
  return match ? Number(match[1]) : null;
};

export const extractOfferIndices = (text: string): Set<number> =>
  new Set(Array.from(text.matchAll(new RegExp(OFFER_TOKEN_PATTERN, 'g')), match => Number(match[1])));

export interface OfferTokenCallbacks {
  offerCount: number;
  onOfferUsed?: (offerIndex: number) => void;
  onAddOffer?: () => void;
}

export const notifyOfferTokenInserted = (token: string, { offerCount, onOfferUsed, onAddOffer }: OfferTokenCallbacks) => {
  const index = offerIndexOf(token);
  if (index === null) return;
  onOfferUsed?.(index);
  if (index >= offerCount) onAddOffer?.();
};
